const settings = {
  appVersion: "2.6",
  apiUrl: "https://txlog.stanglware.com/svc",
  // apiUrl: "https://bisdlog.stanglware.com/svc",
  // apiUrl: "http://localhost:4000",
  // apiUrl: "http://10.0.0.72:4000",
  getDataEndpoint: "/data/GetData",
  saveDataEndpoint: "/data/SaveData",
};

export const getAppSettings = () => {
  return settings;
}
